import { createAction, props } from '@ngrx/store'
import { ChangeRequest } from '@app/core/model/change-request.model'

export enum ChangeRequestScenarioActionTypes {
  SAVE_SCENARIO_CONFIG = '[Change Request] Save Scenario Config',
  SAVE_SCENARIO_CONFIG_SUCCESS = '[Change Request] Save Scenario Config Success',
  SAVE_SCENARIO_CONFIG_FAIL = '[Change Request] Save Scenario Config Fail',
  GENERATE_CHANGES_FROM_SCENARIO_CONFIG = '[Change Request] Generate Changes From Scenario Config',
  GENERATE_CHANGES_FROM_SCENARIO_CONFIG_SUCCESS = '[Change Request] Generate Changes From Scenario Config Success',
  GENERATE_CHANGES_FROM_SCENARIO_CONFIG_FAIL = '[Change Request] Generate Changes From Scenario Config Fail',
}

const saveScenarioConfig = createAction(
  ChangeRequestScenarioActionTypes.SAVE_SCENARIO_CONFIG,
  props<{
    scopeId: number
    changeRequestId: number
    configuration: any
    oldConfiguration: any
    componentModifiers: Record<number, number>
    oldComponentModifiers: Record<number, number>
    changeItemId?: string
  }>()
)

const saveScenarioConfigSuccess = createAction(
  ChangeRequestScenarioActionTypes.SAVE_SCENARIO_CONFIG_SUCCESS,
  props<{ changeItem: any }>()
)

const saveScenarioConfigFail = createAction(
  ChangeRequestScenarioActionTypes.SAVE_SCENARIO_CONFIG_FAIL,
  props<{ error: Error }>()
)

const generateChangesFromScenarioConfig = createAction(
  ChangeRequestScenarioActionTypes.GENERATE_CHANGES_FROM_SCENARIO_CONFIG,
  props<{ scopeId: number; changeRequestId: number }>()
)

const generateChangesFromScenarioConfigSuccess = createAction(
  ChangeRequestScenarioActionTypes.GENERATE_CHANGES_FROM_SCENARIO_CONFIG_SUCCESS,
  props<{ changeRequest: ChangeRequest }>()
)

const generateChangesFromScenarioConfigFail = createAction(
  ChangeRequestScenarioActionTypes.GENERATE_CHANGES_FROM_SCENARIO_CONFIG_FAIL,
  props<{ error: Error }>()
)

export const ChangeRequestScenarioActions = {
  saveScenarioConfig,
  saveScenarioConfigSuccess,
  saveScenarioConfigFail,
  generateChangesFromScenarioConfig,
  generateChangesFromScenarioConfigSuccess,
  generateChangesFromScenarioConfigFail,
}
